interface TextProps {
  children: React.ReactNode;
  className?: string;
}

export const Text = (props: TextProps) => {
  const { className, children } = props;

  return <p className={className}>{children}</p>;
};
